import { ReportParametersDto } from "./reportDto";

// eslint-disable-next-line
export interface OutsideProcessContractsSentButNotReceivedReportDto extends ReportParametersDto {}

export class OutsideProcessContractsSentButNotReceivedReportDto implements OutsideProcessContractsSentButNotReceivedReportDto {
	constructor(data?: Partial<OutsideProcessContractsSentButNotReceivedReportDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}